<template>
  <div class="modal" id="modal-create-coupon" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Create Coupon
          </h5>
        </div>

        <div class="modal-body">
          <form role="form">
            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

              <div class="col-md-6">
                <input id="name"
                       type="text"
                       class="form-control"
                       name="name"
                       v-model="createCouponForm.name"
                       :class="{'is-invalid': createCouponForm.errors.has('name')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="createCouponForm.errors.has('name')">
                  <strong>{{ createCouponForm.errors.get('name') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="code" class="col-md-4 col-form-label text-md-right">Code</label>

              <div class="col-md-6">
                <input id="code"
                       type="text"
                       class="form-control"
                       name="code"
                       v-model="createCouponForm.code"
                       :class="{'is-invalid': createCouponForm.errors.has('code')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="createCouponForm.errors.has('code')">
                  <strong>{{ createCouponForm.errors.get('code') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="couponType" class="col-md-4 col-form-label text-md-right">
                Type
              </label>

              <div class="col-md-6">
                <div class="form-check">
                  <input v-model="createCouponForm.coupon_type" class="form-check-input" id="couponTypePercentage"
                         type="radio" name="coupon_type"
                         value="percentage">
                  <label class="form-check-label" for="couponTypePercentage">
                    Percentage
                  </label>
                </div>

                <div class="form-check">
                  <input v-model="createCouponForm.coupon_type" class="form-check-input" id="couponTypeAmount"
                         type="radio" name="coupon_type"
                         value="amount">
                  <label class="form-check-label" for="couponTypeAmount">
                    Amount
                  </label>
                </div>
              </div>
            </div>

            <div class="text-danger font-weight-bold text-sm col-md-6 offset-md-4"
                 role="alert"
                 v-if="createCouponForm.errors.has('coupon_type')">
              <h6>{{ createCouponForm.errors.get('coupon_type') }}</h6>
            </div>

            <div v-if="createCouponForm.coupon_type === 'percentage'" class="form-group row">
              <label for="percentage" class="col-md-4 col-form-label text-md-right">Percentage off</label>
              <div class="col-md-6">
                <input id="percentage" type="number" min="0" max="100"
                       v-model="createCouponForm.percentage"
                       class="form-control"
                       :class="{'is-invalid': createCouponForm.errors.has('percentage')}"
                       name="percentage"
                       required>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="createCouponForm.errors.has('percentage')">
                  <strong>{{ createCouponForm.errors.get('percentage') }}</strong>
                </span>
              </div>
            </div>

            <div v-if="createCouponForm.coupon_type === 'amount'" class="form-group row">
              <label for="amount" class="col-md-4 col-form-label text-md-right">Discount amount</label>
              <div class="col-md-6">
                <input id="amount" type="number" min="0"
                       v-model="createCouponForm.amount"
                       class="form-control"
                       :class="{'is-invalid': createCouponForm.errors.has('amount')}"
                       name="amount"
                       required>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="createCouponForm.errors.has('amount')">
                  <strong>{{ createCouponForm.errors.get('amount') }}</strong>
                </span>
              </div>
            </div>


            <div class="form-group row">
              <div class="col-md-4 text-md-right">
                <input v-model="limitNumberUsageChecked"
                       id="limit_number_usage_status"
                       type="checkbox"
                       class="form-control-sm"
                       :class="{'is-invalid': createCouponForm.errors.has('limit_count')}">
              </div>
              <label for="limit_number_usage_status" class="col-md-6 col-form-label">
                Limit the number of usage
              </label>
            </div>

            <div v-if="limitNumberUsageChecked" class="form-group row">
              <div class="col-md-6 offset-md-4">
                <input v-model="createCouponForm.limit_count"
                       id="limit_count"
                       type="number"
                       :class="{'is-invalid': createCouponForm.errors.has('limit_count')}"
                       class="form-control">
                <span class="invalid-feedback"
                      role="alert"
                      v-if="createCouponForm.errors.has('limit_count')">
                  <strong>{{ createCouponForm.errors.get('limit_count') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4 text-md-right">
                <input v-model="limitDateChecked"
                       id="limit_date_status"
                       type="checkbox"
                       class="form-control-sm"
                       :class="{'is-invalid': createCouponForm.errors.has('limit_count')}">
              </div>
              <label for="limit_date_status" class="col-md-6 col-form-label">
                Limit the date when coupon can be used
              </label>
            </div>

            <div v-if="limitDateChecked" class="form-group row">
              <div class="col-md-6 offset-md-4">
                <input v-model="createCouponForm.ends_at"
                       id="ends_at"
                       type="date"
                       class="form-control">
                <span class="text-sm text-danger font-weight-bold"
                      role="alert"
                      v-if="createCouponForm.errors.has('ends_at')">
                  <strong>{{ createCouponForm.errors.get('ends_at') }}</strong>
                </span>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          <button type="submit"
                  class="btn btn-primary"
                  @click.prevent="createCoupon">
            Create
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import App from '../../../forms/http';

export default {

  data () {
    return {
      createCouponForm: new AppForm({
        _token: App.csrfToken,
      }),
      limitDateChecked: false,
      limitNumberUsageChecked: false,
    };
  },

  methods: {
    createCoupon () {
      let self = this;

      if (this.createCouponForm.coupon_type === 'percentage') {
        delete this.createCouponForm.amount;
      } else {
        delete this.createCouponForm.percentage;
      }

      if (!this.limitNumberUsageChecked) {
        delete this.createCouponForm.limit_count;
      }

      if (!this.limitDateChecked) {
        delete this.createCouponForm.ends_at;
      }

      App.post('/api/coupons', this.createCouponForm)
        .then(() => {
          self.createCouponForm.name = null;
          self.createCouponForm.code = null;
          self.createCouponForm.coupon_type = null;
          self.createCouponForm.limit_count = null;
          self.createCouponForm.amount = null;
          self.createCouponForm.ends_at = null;
          self.createCouponForm.percentage = null;

          $('#modal-create-coupon').modal('hide');
          self.$parent.$emit('updateCoupons');
        });
    },
  }
};
</script>
